import React, { Component } from 'react';
import {resolveVariables} from 'functions';

class RadioButton extends React.Component {
    static component_name = 'RadioButton';
                render() {
                    return (
                        <div>
                            <input type="radio" id={this.props.value} name={this.props.name} />
                            <label htmlFor={this.props.value}>{this.props.value}</label>
                        </div>

                    );
                }
            }


export default RadioButton;
